import { initializeUtagEvents } from './sustainable_info.analytics'

export function init(blockId) {
  const blockSelector = `[data-block-id="${blockId}"]`
  const block = document.querySelector(blockSelector)

  block.style.height = 'auto'
  const wrapper = block.querySelector('.wrapper')
  wrapper.classList.remove('visibility-hidden')

  initializeUtagEvents()
}
